import { locationsActionTypes } from '../constants/ApiConstants';

const initialState = {
  masterData: null,
  LocationsList: null,
  LocationsDetail: null,
  saved_locations: null,
  deleted_locations: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case locationsActionTypes.get_masterData.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case locationsActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
  case locationsActionTypes.save_locations.REQUEST:
    return {
      ...state,
      loading: true,
      saved_locations: null,
    };
  case locationsActionTypes.save_locations.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_locations: payload,
    };
  case locationsActionTypes.get_locationsList.REQUEST:
    return {
      ...state,
      loading: true,
      LocationsList: null,
    };
  case locationsActionTypes.get_locationsList.SUCCESS:
    return {
      ...state,
      loading: false,
      LocationsList: payload,
    };
  case locationsActionTypes.get_locationsDetail.REQUEST:
    return {
      ...state,
      loading: true,
      LocationsDetail: null,
    };
  case locationsActionTypes.get_locationsDetail.SUCCESS:
    return {
      ...state,
      loading: false,
      LocationsDetail: payload,
    };
  case locationsActionTypes.delete_locations.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_locations: null,
    };
  case locationsActionTypes.delete_locations.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_locations: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Locations/reducers/locationsReducer.js